import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import Grid from "../../components/grid/grid";
import axiosInstance from "../../api/axiosInstance";
import EventSlider from "../../components/eventSlider/eventSlider";
import Loading from "../../components/loading/loading";
import "./home.scss";

const Home = () => {
    const [posts, setPosts] = useState([]);
    const [eventsToday, setEventsToday] = useState([]);
    const [isLoading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const [postsRes, eventsTodayRes] = await Promise.all([
                axiosInstance.get('events'),
                axiosInstance.get('events')
            ]);
            setPosts(postsRes.data);
            setEventsToday(eventsTodayRes.data);
            setLoading(false);
        } catch (err) {
            console.error(err);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return isLoading ? (<Loading />) : (
        <div className="home">
            <Helmet>
                <title>wosgeat</title>
            </Helmet>
            <div className="header">
                <div className="container">
                    <div className="title">
                        <h4>Was steht heute an</h4>
                        <Link to={"/kalender"}>Zum Kalender</Link>
                    </div>
                    <EventSlider
                        items={eventsToday}
                    />
                </div>
            </div>
            <div className="eventsFeed">
                <div className="container">
                    <Grid
                        items={posts}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </div>
    )
};

export default Home